import { isHubSpotNativeApp } from '../../../utils/utils';
// @ts-expect-error no types
import StolenFaceNav from '../../../components/StolenFaceNav';
import UIFlex from 'UIComponents/layout/UIFlex';
// @ts-expect-error no types
import HubspotSoftwareNavHider from '../../../containers/HubspotSoftwareNavHider';
import styled, { theme, useMediaQuery } from 'academy-common-lib/utils/Styling';
import NavbarMobileTabs from './NavbarMobileTabs';
import NavbarTabs from './NavbarTabs';
import AcademyToSoftware from '../../../containers/AcademyToSoftware/AcademyToSoftware';
import { DevtoolsButton } from '../../devtools';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StickyNav = styled.nav.withConfig({
  displayName: "Navbar__StickyNav",
  componentId: "sc-1q8xrw5-0"
})(["display:flex;background:", ";position:sticky;z-index:4;top:", ";"], theme.colors.PANTERA, props => props.mobile ? 54 : 0);
const NavSeparator = styled.div.withConfig({
  displayName: "Navbar__NavSeparator",
  componentId: "sc-1q8xrw5-1"
})(["height:28px;width:1px;background:", ";margin:4px 6px 0 18px;"], theme.colors.SLINKY);
export const Navbar = () => {
  const {
    isMobileNavbar
  } = useMediaQuery();
  const isMobileApp = window.navigator.userAgent.indexOf('HubSpotiOS') > -1 || window.navigator.userAgent.indexOf('HubSpotAndroid') > -1;
  return /*#__PURE__*/_jsxs(StickyNav, {
    id: "academy-nav",
    mobile: isMobileApp,
    children: [/*#__PURE__*/_jsx(HubspotSoftwareNavHider, {}), isMobileNavbar ? /*#__PURE__*/_jsx(NavbarMobileTabs, {}) : /*#__PURE__*/_jsx(NavbarTabs, {}), !isHubSpotNativeApp && /*#__PURE__*/_jsx("div", {
      className: "vr-hidden",
      style: {
        width: 'fit-content'
      },
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        style: {
          height: '48px',
          paddingLeft: '20px',
          maxWidth: 'fit-content',
          marginLeft: 'auto'
        },
        children: [/*#__PURE__*/_jsx(AcademyToSoftware, {}), /*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          children: [/*#__PURE__*/_jsx(NavSeparator, {}), /*#__PURE__*/_jsx(DevtoolsButton, {}), /*#__PURE__*/_jsx(StolenFaceNav, {})]
        })]
      })
    })]
  });
};